const requestErrorMessages = {
  RESPONSE_500:
    'Something has gone wrong when handling your request. Our development team has been notified and will attend to it as soon as possible',
};

export default requestErrorMessages;
